import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  tagsList: [],
  selectedTag: "",
  selectedTags: [],
  newTag: "",
  isOpenCreateTagModal: false,
  isUpdateTagList: false,
  isOpenSelectTagsModal: false,
};

const TagsReducer = createSlice({
  name: "TagsReducer",
  initialState: initialState,
  reducers: {
    setTagsList: (state, { payload }) => {
      return {
        ...state,
        tagsList: payload,
        isUpdateTagList: false,
      };
    },

    setSelectTag: (state, { payload }) => {
      return {
        ...state,
        selectedTag: payload,
      };
    },

    openCreateTagModal: (state) => {
      return {
        ...state,
        isOpenCreateTagModal: true,
      };
    },

    openSelectTagsModal: (state) => {
      return {
        ...state,
        isOpenSelectTagsModal: true,
      };
    },

    updateTagsList: (state, { payload }) => {
      let newList = [...state.tagsList];
      for (let index = 0; index < newList.length; index++) {
        if (newList[index].tag_id === payload.tag_id) {
          newList[index] = payload;
        }
      }
      return {
        ...state,
        tagsList: newList,
      };
    },
    addList: (state, { payload }) => {
      let newList = [...state.tagsList];
      newList.push(payload);
      return {
        ...state,
        tagsList: newList,
        // selectedTags: [...state.selectedTags, payload.tag_id],
        newTag: payload,
        isUpdateTagList: true,
      };
    },

    closeCreateTagModal: (state) => {
      return {
        ...state,
        isOpenCreateTagModal: false,
      };
    },

    setSelectedTags: (state, { payload }) => {
      return {
        ...state,
        selectedTags: payload,
      };
    },

    closeSelectTagsModal: (state) => {
      return {
        ...state,
        isOpenSelectTagsModal: false,
      };
    },

    clearNewTag: (state) => {
      return {
        ...state,
        newTag: "",
      };
    },

    clearSelectItems: (state) => {
      return {
        ...state,
        selectedTag: "",
        selectedTags: [],
      };
    },
  },
});
export default TagsReducer;
